import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import styled from 'styled-components';

import {
  distanceFlexSection,
  flexSection,
  listItemSection,
  locationListItemHours,
} from 'constants/styles';
import buttonTypes from 'constants/buttonTypes';
import reservationServiceTypes from 'constants/reservationServiceTypes';

import LocationNameDisplay from 'components/LocationNameDisplay';
import Button from 'components/Button';
import LinkButton from 'components/LinkButton';

import multiButtonProps, {
  DEFAULT_MULTI_BUTTON_PROPS,
} from 'constants/multiButtonProps';
import MultiButtonComponent from 'components/MultiButtonComponent';

const ButtonSection = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export default class LocationListItemComponent extends React.Component {
  getGoogleMapsUrl = () => {
    const { location } = this.props;
    const googleMapsUri = 'https://www.google.com/maps/search/?api=1';
    let searchUrl = '';
    const lat = parseFloat(location.lat);
    const lng = parseFloat(location.lng);
    if (location.google_place_id) {
      searchUrl = `${googleMapsUri}&query=${lat},${lng}&query_place_id=${location.google_place_id}`;
    } else {
      const urlSafeAddress = encodeURI(location.address);
      searchUrl = `${googleMapsUri}&query=${urlSafeAddress}`;
    }
    return searchUrl;
  };

  renderHours = () => {
    const { location } = this.props;
    return { __html: location.hours };
  };

  displayCustomButton = () => {
    const { location } = this.props;
    return (
      location.store_locator_custom_button_text &&
      location.store_locator_custom_button_url
    );
  };

  displayMultiButton = () => {
    const { displayMultiButton, multiButton, chowNowId, location } = this.props;

    const shouldDisplayMultiButton =
      displayMultiButton &&
      multiButton !== undefined &&
      multiButton.button_type !== buttonTypes.NONE;

    const hasIntegrationForReservation =
      location.fields &&
      location.fields.reservations &&
      location.fields.reservations.service != reservationServiceTypes.NONE;

    const hasRequiredInformation =
      (multiButton.button_type !== buttonTypes.RESERVATIONS ||
        hasIntegrationForReservation) &&
      (multiButton.button_type !== buttonTypes.ONLINE_ORDERING ||
        chowNowId !== null);

    return shouldDisplayMultiButton && hasRequiredInformation;
  };

  render() {
    const {
      displayMoreInfo,
      multiButton,
      location,
      handleNameClick,
      chowNowId,
    } = this.props;

    return (
      <div className="locationListItem" style={listItemSection}>
        <LocationNameDisplay name={location.name} url={location.url} />
        {location.address && (
          <span style={flexSection}>
            <a href={this.getGoogleMapsUrl()} target="_blank">
              {location.address}
            </a>
          </span>
        )}
        {location.phone_number && (
          <span style={flexSection}>
            <a href={`tel:${location.phone_number}`}>{location.phone_number}</a>
          </span>
        )}
        {location.hours && (
          <div style={flexSection}>
            <div
              style={locationListItemHours}
              className="locationListItemHours"
              dangerouslySetInnerHTML={this.renderHours()}
            />
          </div>
        )}
        {location.distance && (
          <div style={distanceFlexSection}>
            <span className="locationListItem-distance">
              {location.distance} miles
            </span>
          </div>
        )}
        <ButtonSection>
          <MediaQuery query="(min-width: 768px)">
            <Button
              className="locationListItem-customButton locationListItem-link"
              label="View on Map"
              aria-label={`View ${location.name} on Map`}
              handleClick={() => handleNameClick(location)}
              addRightMargin
              addTopMargin
            />
          </MediaQuery>
          {displayMoreInfo && (
            <LinkButton
              className="locationListItem-customButton locationListItem-link"
              label="Location Details"
              aria-label={`Read more about ${location.name}`}
              href={location.url}
              addTopMargin
            />
          )}
        </ButtonSection>
        {this.displayCustomButton() && (
          <LinkButton
            className="locationListItem-customButton locationListItem-link"
            label={location.store_locator_custom_button_text}
            addTopMargin
            href={location.store_locator_custom_button_url}
            isExternal
          />
        )}
        {this.displayMultiButton() && (
          <MultiButtonComponent
            {...multiButton}
            chowNowId={chowNowId}
            locationSlug={location.slug}
          />
        )}
      </div>
    );
  }
}

LocationListItemComponent.propTypes = {
  chowNowId: PropTypes.string,
  displayMoreInfo: PropTypes.bool.isRequired,
  displayMultiButton: PropTypes.bool,
  handleNameClick: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  multiButton: PropTypes.shape(multiButtonProps),
};

LocationListItemComponent.defaultProps = {
  chowNowId: null,
  displayMultiButton: false,
  multiButton: { ...DEFAULT_MULTI_BUTTON_PROPS },
};
